import React, { useState } from 'react';

import Show from 'components/Show';
import Modal from 'components/Modal';
import Action from 'components/Misc/Action';
import Nothing from 'components/Misc/Nothing';
import { Title } from 'components/Misc/Typography';
import { Button, Currency, Select } from 'components/Misc/Form';

import Payment from 'containers/Administrator/Users/Profile/Student/Payments/Generate/Payment';

import { useStudentPaymentStore } from 'store/user/useStudentPaymentStore';

const Generate = ({ gradeId }) => {
	// Store modal's visibility
	const [modal, setModal] = useState(false);

	// Use student's payment store
	const grade = useStudentPaymentStore(state => state.grades.find(g => g.id === gradeId));
	const [generator, onChange, onGenerate, onAdd, onInit, onReset] = useStudentPaymentStore(state => [
		state.generator,
		state.onChangeGenerator,
		state.onGeneratePayments,
		state.onAddGeneratedPayments,
		state.onInitGenerator,
		state.onResetGenerator
	]);

	// Handle generated payment addition
	const handleAdd = () => {
		onAdd();
		setModal(false);
	};

	// Toggle modal's visibility
	const handleModal = () => {
		// Initialize generator's data on open
		if (!modal) onInit(grade);

		// Reset generator's data on close
		if (modal) onReset();

		// Toggle modal
		setModal(m => !m);
	};

	return (
		<>
			<Action
				icon="receipt"
				title="Ģenerēt maksājumus"
				subtitle="Uzģenerēt maksājumu grafiku"
				onClick={handleModal}
			/>
		
			<Modal title="Maksājumu ģenerēšana" visible={modal} handleModal={handleModal}>
				<div className="space-y-4">
					<div className="grid grid-cols-2 gap-4">
						<Currency
							name="price"
							label="Summa"
							value={generator.price}
							onChange={onChange}
						/>

						<Select
							name="sections"
							label="Maksājumu skaits"
							placeholder=" "
							value={generator.sections}
							onChange={onChange}
							options={[
								{ value: 1, name: '1. daļa' },
								{ value: 2, name: '2. daļas' },
								{ value: 9, name: '9. daļas' }
							]}
						/>

						<div className="col-span-2 flex justify-end">
							<Button
								icon="double_arrow"
								theme="success"
								value="Ģenerēt"
								onClick={onGenerate}
							/>
						</div>
					</div>

					<Title title="Maksājumu grafiks" />

					{/* Show nothing if no payments added */}
					<Nothing visible={!generator?.payments?.length} />

					{/* Show payment collection */}
					<Show if={generator?.payments?.length}>
						<div className="space-y-4">
							{generator?.payments?.map(payment => (
								<Payment key={payment.key} payment={payment} />
							))}
						</div>
					</Show>

					<div className="col-span-2 flex justify-end">
						<Button
							icon="check"
							theme="success"
							value="Pievienot maksājumus"
							onClick={handleAdd}
						/>
					</div>
				</div>
			</Modal>
		</>
	);
};

export default Generate;